import utils from '../../../../../components/Organisms/Form/utils'
import globalConfig from '../../../../../components/Organisms/Form/config'
import { ConfigCompanyDetails } from './types'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

const config = ({ countries, countryTelephoneCodes, formType }: ConfigCompanyDetails & {formType?: string}) => utils.injectTranslation({
  id: 'CompanyDetailsForm',
  path: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'companyFullName',
            required: true,
            maxlength: formType === 'Deliverable' ? 100 : 200,
          },
        },
        {
          componentType: 'date',
          transformType: 'date',
          submitValidation: 'date',
          props: {
            name: 'dateOfIncorporation',
            noFuture: true,
            required: true,
            dontClearValue: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'registrationNo',
            required: true,
            maxlength: 100,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'registeredOfficeAddress',
            required: true,
            isTextarea: true,
            textAreaHeight: '48px',
            textAreaPointerEvents: 'auto',
            resize: 'none',
            maxlength: formType === 'Deliverable'? 100 : 250,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'registeredCity',
            required: true,
            maxlength: 100,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'registeredPostCode',
            required: true,
            maxlength:  formType === 'Deliverable'? 100 : 50,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'registeredCountry',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'registeredCountry',
            label: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.registeredCountry.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.registeredCountry.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          transformType: 'stringToNumOrViceVersa',
          submitValidation: 'numberGreaterThanZero',
          props: {
            name: 'noOfEmployees',
            pattern: globalConfig?.regex?.number,
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'countryOfIncorporation',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'countryOfIncorporation',
            label: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.countryOfIncorporation.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.countryOfIncorporation.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          props: {
            name: 'registeredTelephoneCountryIndex',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countryTelephoneCodes,
            name: 'registeredTelephoneCountryIndex',
            label: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.registeredTelephoneCountryIndex.label',
            placeholder: 'onboarding.forms.CorporateAccount.CompanyDetailsForm.inputs.registeredTelephoneCountryIndex.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          transformType: 'transformValidationTelephoneCodePlusNumber',
          props: {
            name: 'validationRegisteredTelephoneCountryIndex',
            show: false,
          },
        },
        {
          componentType: 'input',
          submitValidation: 'telephoneWithMinimum',
          transformType: 'transformTelephoneNumber',
          props: {
            name: 'registeredTelephoneNo',
            pattern: formType === 'Deliverable' ? globalConfig?.regex?.telephoneNoPlusSignal100 : globalConfig?.regex?.telephoneNoPlusSignal50,
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'tradingName',
            maxlength:  formType === 'Deliverable'? 100 : 200,
          },
        },
        {
          componentType: 'input',
          submitValidation: 'email',
          props: {
            name: 'registeredEmailAddress',
            required: true,
            maxlength: 100,
          },
        },
      ],
    },
  ],
})

export default config
